import { Link } from "wouter";
import { Header } from "@/components/public/header";
import { Footer } from "@/components/public/footer";
import { Container } from "@/components/public/institutional-ui";
import { FadeIn } from "@/components/ui/scroll-animations";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 flex items-center pt-[4.5rem]">
        <Container className="py-24 text-center">
          <FadeIn>
            <p className="gc-eyebrow text-muted-foreground mb-4">404</p>
            <h1 className="gc-heading-page mb-6">Page not found</h1>
            <p className="text-muted-foreground max-w-md mx-auto mb-10 leading-relaxed">
              The page you are looking for does not exist or has been moved.
            </p>
            <Link href="/">
              <span className="gc-btn-primary cursor-pointer inline-flex">Return home</span>
            </Link>
          </FadeIn>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
